
import React from "react";
import { Container , Col , Row } from 'reactstrap';
import  './Commonsection.css';


function  Commonsection  ({title}) {
    return(
        <section  className="common__section">
            <Container  className="text-center">
                <h2>
                    {
                        title
                    }
                </h2>
            </Container>

        </section>
    );
}

export default Commonsection;

